export const _getReplaceAccessForm = (state, action) => action.payload;

export const _setReplaceAccessUsers = (state, action) => {
  state.replaceAccessUsers = action.payload;
};
